import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { usePageTitle } from '../lib/usePageTitle';

export const PaymentSuccess: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    usePageTitle('Order Confirmed');
    const sessionId = searchParams.get('session_id');

    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-8">
            <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
            <h1 className="text-2xl font-bold mb-2">Payment Successful!</h1>
            <p className="text-gray-600 mb-6">Thank you for your order. We have received your payment.</p>
            <div className="flex gap-4">
                <button
                    onClick={() => navigate('/orders')}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                    View All Orders
                </button>
            </div>
            {sessionId && <p className="mt-4 text-xs text-gray-400">Session ID: {sessionId}</p>}
        </div>
    );
};
